<template>
  <div>
      <hr />

      <p>
        <strong>Child #{{ parseInt(index)+1 }}</strong>
      </p>

      <div class="form-group" :class="{ 'error': $v.child.first_name.$error }">
        <label :for="'child_first_name'+index">First name of missing child</label>
        <div class="input-group">
          <input type="text" name="child_first_name" :id="'child_first_name'+index" v-model.trim="$v.child.first_name.$model" required />
          <p class="form-error" v-if="$v.child.first_name.$error && !$v.child.first_name.required">
            This field is required
          </p>
        </div>
      </div>

      <div class="form-group" :class="{ 'error': $v.child.last_name.$error }">
        <label :for="'child_last_name'+index">Last name of missing child</label>
        <div class="input-group">
          <input type="text" name="child_last_name" :id="'child_last_name'+index" v-model.trim="$v.child.last_name.$model" required />
          <p class="form-error" v-if="$v.child.last_name.$error && !$v.child.last_name.required">
            This field is required
          </p>
        </div>
      </div>

      <div class="form-group" :class="{ 'error': $v.child.age.$error }">
        <label :for="'child_age'+index">Age of missing child</label>
        <div class="input-group">
          <input type="text" name="child_age" :id="'child_age'+index" v-model.trim="$v.child.age.$model" required />
          <p class="form-error" v-if="$v.child.age.$error && !$v.child.age.required">
            This field is required
          </p>
          <p class="form-error" v-if="$v.child.age.$error && !$v.child.age.numeric">
            Please enter a number
          </p>
          <p class="form-error" v-if="$v.child.age.$dirty && $v.child.age.required && $v.child.age.$error && !$v.child.age.between">
            Child’s age must be between {{ $v.child.age.$params.between.min }} and {{ $v.child.age.$params.between.max }}
          </p>
        </div>
      </div>


  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, email, numeric, between, requiredIf } from 'vuelidate/lib/validators'

export default {
  name: 'MissingChildIntakeFormChild',

  props: {
    child: { type: Object, required: true },
    index: { type: Number, required: true }
  },

  mixins: [validationMixin],

  data() {
    return {

    }
  },

  validations() {
    let v = {
      child: {
          first_name: { required },
          last_name: { required },
          age: {
            required,
            numeric,
            between: between(0, 99)
          },
      }
    }

    return v
  },

  methods: {
  },

}
</script>



// WEBPACK FOOTER //
// js/MissingChildIntakeFormChild.vue